import { Box, Grid, Paper, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DAY_NIGHT_TEXT_COLOR, DailyWeather, DailyWeatherUnit, HourlyWeather, weatherCodes } from "../types/Weather";
import HourlyWeatherSlider from "./HourlyWeatherSlider";

const TomorrowWeatherMainSection = ({ tomorrowHourlyWeather, tomorrowDailyWeather, dailyWeatherUnit }: {
  tomorrowHourlyWeather: HourlyWeather[],
  tomorrowDailyWeather: DailyWeather,
  dailyWeatherUnit: DailyWeatherUnit,
}) => {
  const tomorrowWeatherCode = weatherCodes.get(tomorrowDailyWeather.weathercode);

  return (
    <Paper
      variant="outlined"
      sx={{
        borderColor: DAY_NIGHT_TEXT_COLOR,
        borderRadius: '16px',
        paddingX: 2,
        paddingY: 4,
        color: DAY_NIGHT_TEXT_COLOR,
        backgroundColor: tomorrowWeatherCode?.dayColor,
      }}>
      <Grid container spacing={2}>
        <Grid item xs={6} sx={{ textAlign: "center" }}>
          <FontAwesomeIcon
            style={{ paddingTop: 20, paddingBottom: 8 }}
            icon={tomorrowWeatherCode?.dayIcon!}
            size="3x" />
          <Typography variant="body1">{tomorrowWeatherCode?.text}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Box>
            <Grid container spacing={4}>
              <Grid item xs={3} md={3}>
                <Typography variant="body1" sx={{ marginTop: 3, marginRight: 1 }}>High</Typography>
              </Grid>
              <Grid item xs={9} md={9}>
                <Box sx={{ display: "flex" }}>
                  <Typography variant="h4" sx={{ marginTop: 2 }}>{tomorrowDailyWeather.temperature_2m_max.toFixed(0)}</Typography>
                  <Typography variant="h6" sx={{ marginTop: 2 }}>{dailyWeatherUnit.temperature_2m_max}</Typography>
                </Box>
              </Grid>
            </Grid>
            <Grid container spacing={4}>
              <Grid item xs={3} md={3}>
                <Typography variant="body1" sx={{ marginTop: 2, marginRight: 1 }}>Low</Typography>
              </Grid>
              <Grid item xs={9} md={9}>
                <Box sx={{ display: "flex" }}>
                  <Typography variant="h4" sx={{ marginTop: 1 }}>{tomorrowDailyWeather.temperature_2m_min.toFixed(0)}</Typography>
                  <Typography variant="h6" sx={{ marginTop: 1 }}>{dailyWeatherUnit.temperature_2m_min}</Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <HourlyWeatherSlider hourlyWeather={tomorrowHourlyWeather} />
    </Paper >
  );
}

export default TomorrowWeatherMainSection;